import * as Yup from "yup"

export class UpdateWorkflowForm
{
	selected: boolean | null = false
}

const WorkflowComponentValidation = {
	selected: Yup.string().max(256).required(),
}

export default Yup.object()
	.shape(
		WorkflowComponentValidation,
	)
	.required()
